module.exports = __webpack_public_path__ + "img/music.a720e266.png";